import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { DataService } from '../data.service';
import { environment } from 'src/environments/environment';
import { YearWithPoints } from './copy-from-year-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class FormsSampleService {
  private endpoint = `${environment.api}/sample-charts`;

  private mpEndpoint = `${environment.api}/measurement-points`;

  constructor(private http: HttpClient, private dataService: DataService) {}

  fetchSample(id: number) {
    return this.http.get(`${this.endpoint}/${id}`);
  }

  createSample(carrier: any, name: string) {
    return this.http.post(`${this.endpoint}`, {});
  }

  createMeasurementPoint(sampleChartId: number): Observable<any> {
    return this.http.post(`${this.mpEndpoint}`, {
      sample_chart: sampleChartId,
    });
  }

  deleteMeasurementPoint(pointId: number): Observable<any> {
    return this.http.delete(`${this.mpEndpoint}/${pointId}`);
  }

  fetchYearsWithMeasurementPoints(
    qualityType: string,
    qualityEndpoint: string,
    sampleFieldName: string
  ): Observable<YearWithPoints[]> {
    const project = this.dataService.getProject();
    console.log('[CopyYear] project:', project);
    console.log('[CopyYear] qualityType:', qualityType, 'qualityEndpoint:', qualityEndpoint, 'sampleFieldName:', sampleFieldName);
    if (!project?.data_years?.length) return of([]);

    return this.dataService.selectedYear.pipe(
      take(1),
      switchMap((currentYear) => {
        console.log('[CopyYear] currentYear:', currentYear);
        console.log('[CopyYear] project.data_years:', project.data_years);
        const qualifyingYears = (project.data_years as any[]).filter(
          (dy) => dy[qualityType] && dy.id !== currentYear?.id
        );
        console.log('[CopyYear] qualifyingYears:', qualifyingYears);
        if (qualifyingYears.length === 0) return of([]);

        return forkJoin(
          qualifyingYears.map((dy) =>
            this.http
              .get<any>(
                `${environment.api}/${qualityEndpoint}/${dy[qualityType]}`
              )
              .pipe(
                switchMap((qualityRecord: any) => {
                  console.log('[CopyYear] qualityRecord for year', dy.year, ':', qualityRecord);
                  const sampleRef = qualityRecord[sampleFieldName];
                  console.log('[CopyYear] sampleId for field', sampleFieldName, ':', sampleRef);
                  if (!sampleRef) return of(null);
                  const sampleChartId = typeof sampleRef === 'object' ? sampleRef.id : sampleRef;
                  if (!sampleChartId) return of(null);
                  return this.http
                    .get<any>(`${this.endpoint}/${sampleChartId}`)
                    .pipe(
                      map((sampleChart: any) => {
                        console.log('[CopyYear] sampleChart:', sampleChart);
                        if (!sampleChart.measurement_points?.length)
                          return null;
                        return {
                          year: dy.year,
                          measurementPoints: sampleChart.measurement_points,
                        } as YearWithPoints;
                      })
                    );
                }),
                catchError((err) => {
                  console.error('[CopyYear] error:', err);
                  return of(null);
                })
              )
          )
        ).pipe(
          map(
            (results) =>
              results.filter((r): r is YearWithPoints => r !== null)
          )
        );
      })
    );
  }

  copyMeasurementPoints(
    sampleChartId: number,
    points: { latitude: number; longitude: number }[]
  ): Observable<any[]> {
    if (points.length === 0) return of([]);
    return forkJoin(
      points.map((point) =>
        this.http.post<any>(`${this.mpEndpoint}`, {
          sample_chart: sampleChartId,
          latitude: point.latitude,
          longitude: point.longitude,
        })
      )
    );
  }

  // you get this information from the strapi realtions
  private getCarrierName(name: string): string {
    const carrierassignments: { [key: string]: string } = {
      air_quality: 'air_quality_aq',
      workspace_air_quality: 'air_quality_waq',
      radiation: 'air_quality_radiation',
      water_quality_effluent: 'effluent_quality',
      surface_quality: 'water_quality_surface',
      groundwater_quality: 'water_quality_groundwater',
      outside_noise: 'noise_co_2_outside',
      workplace_noise: 'noise_co_2_workplace',
    };
    return carrierassignments[name];
  }
}
